import { shipmentItemInventoryStatus } from './get-item-inventory-status';
import itemsTableStyles from '../../../../items/items-table/style.module.less';

const itemInventoryStatusToClassNameMap = {
  [shipmentItemInventoryStatus.hasLowStock]: itemsTableStyles['has-low-stock'],
};

export const getItemInventoryClassName = (shouldShowInventoryInfoUiTreatments, itemInventoryStatus) => {
  if (!shouldShowInventoryInfoUiTreatments) {
    return undefined;
  }

  return itemInventoryStatusToClassNameMap[itemInventoryStatus];
};
